import { Component, OnInit, Inject, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { DataMessageModel } from '@core/model/dataMessage.model';
import { CommonService } from '@shared/service/common.service';
import { GenericSliderService } from '@shared/service/genericSlider.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { GenericSlidersModel } from '@core/model/genericSliders.model';
import { ModelsService } from '@shared/service/models.service';
import { ShoppingCartLineModel } from '@core/model/shoppingCartLine.model';
import { utiles } from '@utl/environment';
import { VilaxInfo } from '@core/model/vilaxInfo.model';
import { DvhInfo } from '@core/model/dvhInfo.model';
import { PrefaReglasInfo } from '@core/model/prefaReglasinfo.model';
import { PrefaSinReglasInfo } from '@core/model/PrefaSinReglasInfo.mode';
import { ModelInfo } from '@core/model/modelInfo.model';

@Component({
  selector: 'app-modal-brc-authorization',
  templateUrl: './modal-brc-authorization.component.html',
  styleUrls: ['./modal-brc-authorization.component.scss']
})

export class ModalBrcAuthorizationComponent implements OnInit {
    private unsubscribe$ = new Subject<void>();
    logoUrl = '';
    policies: any;
    status: any;
    acceptTerms = false;
    onAdd = new EventEmitter();
    onCancel = new EventEmitter();
    details = [];
    listaModelos = [];

    constructor(
        public dialogRef: MatDialogRef<ModalBrcAuthorizationComponent>,
        @Inject(MAT_DIALOG_DATA) public dataMessage: DataMessageModel,
        private common: CommonService,
        private genericSliderService: GenericSliderService,
        private ModelsService: ModelsService,
    ) {
        if (this.dataMessage !== null && this.dataMessage !== undefined) {
            this.status = this.dataMessage.status;
            this.details = this.dataMessage.dataModel;
            this.acceptTerms = this.dataMessage.checked;
        }
    }

    ngOnInit() {
      this.onGetLogo();
      this.onPrivacy();
      this.buscaRestricciones();
    }

    onGetLogo() {
      this.genericSliderService.getLogo()
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          response => {
              this.logoUrl = response.UrlImage;
          },
        );
    }

    onPrivacy() {
    let model = new GenericSlidersModel();
    model.SliderId = 'ARTICULOS_BRC';
    model.Company = utiles.getCacheUser().Company;
    this.genericSliderService.getSliderImages(model)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(response => {
        this.policies = response;
      });
    }

    accept() {
      this.dialogRef.close();
      this.onAdd.emit(this.acceptTerms);
    }

    cancel() {
      this.dialogRef.close();
      this.onAdd.emit(this.dataMessage.checked);
    }

    async buscaRestricciones() {
      let ret = false;
      let listaRestricciones;
      let i = 0;
      let element: ShoppingCartLineModel;

      for (i=0; i<= this.details.length-1; i++) {
        element = this.details[i];
        if (element.ConfiguratedProduct === true) {
          listaRestricciones = [];
          let model = await this.ModelsService.getModelInformation(element.Id).then()
          listaRestricciones = this.getChildRestrictions(model, listaRestricciones);
          if (listaRestricciones.length > 0) {
            model.vListaRestricciones = listaRestricciones;
            this.listaModelos.push(model);
          }
        }
      }
    }

    getChildRestrictions(modelTmp: ModelInfo, listaRestricciones: any[] = []) {
        let modelVilaxTmp: VilaxInfo;
        let modelDVHTmp: DvhInfo;
        let modelPrefaTmp: PrefaReglasInfo;
        let modelPrefaSinReglasTmp: PrefaSinReglasInfo;
    
        modelTmp.vListaRestricciones.forEach(element => {
          listaRestricciones.push(element);
        });

        if (modelTmp.vModelo === 'VILAX') {
          modelVilaxTmp = modelTmp as VilaxInfo;
          modelVilaxTmp.vListaLuzCapa.forEach(element => {
            listaRestricciones = this.getChildRestrictions(element.vModelo, listaRestricciones);
          });
        } else if (modelTmp.vModelo === 'DVH') {
          modelDVHTmp = modelTmp as DvhInfo;
          modelDVHTmp.vListaLuzCapa.forEach(element => {
            listaRestricciones = this.getChildRestrictions(element.vModelo, listaRestricciones);
          });
        } else if (modelTmp.vModelo !== 'VIDRIO CORTADO'){
          if(modelTmp.vTieneReglas){
            modelPrefaTmp = modelTmp as PrefaReglasInfo;
            modelPrefaTmp.vListaLuzCapa.forEach(element => {
              listaRestricciones = this.getChildRestrictions(element.vModelo, listaRestricciones);
            });
          } else {
            modelPrefaSinReglasTmp = modelTmp as PrefaSinReglasInfo;
            modelPrefaSinReglasTmp.vListaLuzCapa.forEach(element => {
              listaRestricciones = this.getChildRestrictions(element.vModelo, listaRestricciones);
            });
          }
        }
    
        return listaRestricciones;
      }
}
